import { IOfferSpendByOfferScopeDetailsTableLang } from '../../../types/lang'

export const offerSpendByOfferScopeDetailsTableLang: IOfferSpendByOfferScopeDetailsTableLang = {
	offer_spend_by_offer_scope_details_table: {
		column_id: 'ID_ua',
		column_date: 'Date_ua',
		column_amount: 'Amount_ua',
		column_account: 'Account_ua',
		column_kt_group: 'KT Group_ua',
		column_offer: 'Offer_ua',
		column_notes: 'Notes_ua',
	}
}